import { useState } from "react";
import { createContainer } from "unstated-next";
import { InoviceTabType } from "../constants";

export function useInvoiceStoreHook() {
  const [currentInvoiceTab, setCurrentInvoiceTab] = useState(
    InoviceTabType.BiilableRecord
  );
  const [orderSelectIds, setOrderSelectIds] = useState([] as string[]);
  const [orderSelectSum, setOrderSelectSum] = useState(0);
  const [currentinvoiceOrderNumber, setCurrentinvoiceOrderNumber] =
    useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showInvoiceTip, setShowInvoiceTip] = useState(true);
  const [openCompanyChangeModal, setOpenCompanyChangeModal] = useState(false);
  const [tipDate, setTipDate] = useState();

  return {
    setCurrentInvoiceTab,
    currentInvoiceTab,
    orderSelectIds,
    setOrderSelectIds,
    orderSelectSum,
    setOrderSelectSum,
    openDrawer,
    setOpenDrawer,
    currentinvoiceOrderNumber,
    setCurrentinvoiceOrderNumber,
    showInvoiceTip,
    setShowInvoiceTip,
    openCompanyChangeModal,
    setOpenCompanyChangeModal,
    tipDate,
    setTipDate,
  };
}

const InvoiceStoreContainer = createContainer(useInvoiceStoreHook);
export const InvoiceStoreContainerProvider = InvoiceStoreContainer.Provider;

export function useInvoiceStore() {
  return InvoiceStoreContainer.useContainer();
}
